
import "@/assets/sass/template.scss";
import { defineComponent, onMounted, ref, computed, watch } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import store from "@/store";
import TableTab from "@/components/kt-datatable/TableTab.vue";
import PaginationUtill from "@/views/util/PaginationUtill";
export default defineComponent({
  name: "DataTable",

  components: {
    TableTab,
  },
  setup() {
    // let accountId = store.getters.AccountId;
    const accountId = computed(() => store.getters.AccountId);
    const tableValuesGas = ref([]);
    const tableValuesElec = ref([]);
    const tableValuesWater = ref([]);
    const elec = ref(false);
    const gas = ref(false);
    const water = ref(false);

    const loading = ref<boolean>(false);
    interface Tableheader {
      name: string;
      key: string;
      sortable: boolean;
    }

    const pageheaderGas = "Asset Register List -Gas";
    const TableHeadersGas = ref<Array<Tableheader>>();
    const OriginalTableHeadersGas = ref<Array<Tableheader>>();
    const colnamesGas = ref();
    const pageheaderElec = "Asset Register List- Electricity";
    const TableHeadersElec = ref<Array<Tableheader>>();
    const OriginalTableHeadersElec = ref<Array<Tableheader>>();
    const colnamesElec = ref();
    const colnamesWater = ref();
    const pageheaderWater = "Asset Register List- Water";
    const TableHeadersWater = ref<Array<Tableheader>>();
    const OriginalTableHeadersWater = ref<Array<Tableheader>>();

    onMounted(() => {
      setCurrentPageBreadcrumbs("Asset Register List", ["NA"]);
      if (accountId.value) {
        loadData(accountId.value);
      }
      elec.value = false;
      gas.value = false;
      water.value = false;
    });

    
    watch(accountId, (newValue) => {
      if (newValue) {
        loadData(newValue);
      }
    });

    const loadData = (id) => {      
      let domainName = store.getters.DomainName;
      const accountInfo: any = {
        accountid: id,
        stIndx: 1,
        enIndx: 5000,
        DomainName: domainName,
      };
      loading.value = true;
      ApiService.post( "api/AssetRegisterSupplier/assetRegisterSupplier", accountInfo )
        .then((resp) => {
          colnamesGas.value = PaginationUtill.getGasColumn.map((a) => a.key);

          OriginalTableHeadersGas.value = PaginationUtill.getGasColumn.map(
            (a) => ({
              name: a.name,
              key: a.key,
              sortable: true,
            })
          );
          TableHeadersGas.value = PaginationUtill.getGasColumn.map((a) => ({
            name: a.name,
            key: a.key,
            sortable: true,
          }));

          tableValuesGas.value = resp.data.assetreggas.map((a) => a);

          colnamesElec.value = PaginationUtill.getElecColumn.map((a) => a.key);

          OriginalTableHeadersElec.value = PaginationUtill.getElecColumn.map(
            (a) => ({
              name: a.name,
              key: a.key,
              sortable: true,
            })
          );
          TableHeadersElec.value = PaginationUtill.getElecColumn.map((a) => ({
            name: a.name,
            key: a.key,
            sortable: true,
          }));

          tableValuesElec.value = resp.data.assetregelec.map((a) => a);
          // Water Asset register
          colnamesWater.value = PaginationUtill.getWaterColumn.map((a) => a.key);

          OriginalTableHeadersWater.value = PaginationUtill.getWaterColumn.map(
            (a) => ({
              name: a.name,
              key: a.key,
              sortable: true,
            })
          );
          TableHeadersWater.value = PaginationUtill.getWaterColumn.map((a) => ({
            name: a.name,
            key: a.key,
            sortable: true,
          }));

          tableValuesWater.value = resp.data.assetregwater.map((a) => a);

          loading.value = false;          

          if(elec.value){
            openAssetElec()
          }
          else if(gas.value){
            openAssetGas()
          }
          else if(water.value){
            openAssetWater()
          }
          else{
            elec.value = true;
          }

        })
        .catch((a) => {
          loading.value = false;
          console.log("API Error", a);
        });
    }
    

    function openAssetElec() {
      elec.value = true;
      gas.value = false;
      water.value = false;
    }

    function openAssetGas() {
      elec.value = false;
      gas.value = true;
      water.value = false;
    }

    function openAssetWater() {
      elec.value = false;
      gas.value = false;
      water.value = true;
    }

    const createAccountInfo = (id) => {
      return {
        accountid: id,
        stIndx: 1,
        enIndx: 5000,
        DomainName: store.getters.DomainName,
      };
    };

    const accountInfo = createAccountInfo(accountId);
    const downloadurl = "api/AssetRegisterSupplier/downloadFile";
    const downloadprops = accountInfo;
    return {
      downloadurl,
      downloadprops,
      pageheaderElec,
      pageheaderGas,
      pageheaderWater,
      colnamesGas,
      colnamesElec,
      colnamesWater,
      openAssetElec,
      openAssetGas,
      openAssetWater,
      elec,
      gas,
      water,
      tableValuesGas,
      tableValuesElec,
      tableValuesWater,
      loading,
      OriginalTableHeadersGas,
      OriginalTableHeadersElec,
      OriginalTableHeadersWater,
    };
  },
});
